import { branch } from '../constants'

module.exports = ->
  configBranch = await Weaver.Branch.load(branch)
  await configBranch.protect() if !configBranch.isProtected()
